import { AfterViewInit, Directive, ElementRef, Input, NgModule, Renderer2 } from '@angular/core';
import { FocusToService } from '@commons/directives/focus-to/focus-to.service';

@Directive({
  selector: '[appFocusTo]',
})
export class FocusToDirective implements AfterViewInit {
  @Input() appFocusTo!: string;
  constructor(
    private readonly elementRef: ElementRef,
    private readonly renderer2: Renderer2,
    private readonly focusService: FocusToService
  ) {}

  ngAfterViewInit(): void {
    this.renderer2.listen(this.elementRef.nativeElement, 'click', (_: Event) => {
      this.focusService.focusTo(this.appFocusTo);
    });
  }
}

@NgModule({
  providers: [FocusToService],
  declarations: [FocusToDirective],
  exports: [FocusToDirective],
})
export class FocusToDirectiveModule {}
